import React, { useMemo } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { ErrorPage_404 } from 'modules/common/routes/ErrorPage';
import { useMeContext } from 'modules/me';
import { RouteTabs, routePathMap } from '../common/routes';
import { useDefaultRoutes } from './useDefaultRoutes';
import { SidePanel } from './SidePanel';
import SubstituteUserBanner from './SubstituteUserBanner';

export const RootPage: React.FC = () => {
  const noteSelectionForm = useForm<Record<string, boolean>>({});
  const defaultRoutes = useDefaultRoutes();

  const me = useMeContext();

  const routeToDisplay = useMemo(
    () => (me?.landingPath ? me.landingPath : routePathMap.notes),
    [me?.landingPath]
  );

  return (
    //to fix type instantiation is excessively deep and infinite
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <FormProvider {...noteSelectionForm}>
      <SubstituteUserBanner />
      <SidePanel />
      <RouteTabs routes={defaultRoutes}>
        <Redirect exact from="/" to={routeToDisplay} />
        <Route path="/404" component={ErrorPage_404} />
        <Redirect to="/404" />
      </RouteTabs>
    </FormProvider>
  );
};
